import { useMutation, useQueryClient } from '@tanstack/react-query'

import { api } from '@/utils/api'

type Args = {
  teamId: string
}

export const useDeleteTeam = () => {
  const queryClient = useQueryClient()

  return useMutation<{ success: boolean }, Error, Args>({
    mutationFn: async ({ teamId }) => {
      const { data } = await api.delete(`/teams/${teamId}`)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['org-teams'] })
    },
  })
}
